/* eslint-disable linebreak-style */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useState, useEffect, useCallback } from 'react';
import { Router, Route, Switch, Redirect } from 'react-router-dom';
import { Layout } from 'antd';
import routes from './routes';
import history from '../services/history';
import LoginPage from '../pages/Login/Login';
import './style.scss';
import Sidebar from '../layout/sidebar';
import NotFoundPage from '../pages/NotFound';
import PublicRoute from './PublicRoute';
import PrivateRoute from './PrivateRoute';
import { authenticateCurrentUser } from '../services/auth';
import { hasWebPageStorageFlag, normalizeCognitoGroups } from '../utils/userGroupUtils';
import { connect } from 'react-redux';
import get from 'lodash/get';
// import { Hub } from 'aws-amplify';
import { Hub } from '@aws-amplify/core';
import ForgotPassword from '../pages/Login/ForgotPassword';
import ResetPassword from '../pages/Login/ResetPassword';
import SignUp from '../pages/Login/SignUp';
import EquipmentCheckComingsoon from '../components/EquipmentCheckComingsoon';
import TechnicalPDFViewer from '../components/CRCE Technical/TechnicalPDFViewer';
import HeatProfilePDFViewer from '../components/Heatprofile/HeatProfilePDFViewer';
import HeatProfileImageViewer from '../components/Heatprofile/HeatProfileImageViewer';
import { ModernLayout } from '../layouts/modern';
import { shouldExcludeFromRedirect } from '../utils/routeHelpers';
import NoAccessPage from '../pages/NoAccessPage';
import { NO_ACCESS_GROUP_KEY } from '../components/AddUserModal';

const AppContainer = (isLogin) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isWebAcess, setIsWebAcess] = useState(false);
  const [userAccess, setUserAccess] = useState([]);
  const [isShowProjectData, setIsShowProjectData] = useState(false);
  const isNoAccessUser = userAccess.includes(NO_ACCESS_GROUP_KEY);

  const syncSessionGroupsFromUser = useCallback((data) => {
    const raw = data.signInUserSession.accessToken.payload['cognito:groups'];
    const groups = normalizeCognitoGroups(raw);
    setUserAccess(groups);
    const webFlag = hasWebPageStorageFlag(groups);
    setIsWebAcess(webFlag);
    localStorage.setItem('is-web-page', webFlag ? 'true' : 'false');
  }, []);

  useEffect(() => {
    const unsubscribe = Hub.listen(
      'auth',
      // eslint-disable-next-line no-unused-vars
      async ({ payload: { event, data } }) => {
        switch (event) {
          case 'cognitoHostedUI': // set user data and get that data below
            break;
          case 'signIn': {
            const isOtpFlow = sessionStorage.getItem('otp_validation_in_progress') === 'true';
            if (isOtpFlow) break;
            try {
              const userData = await authenticateCurrentUser();
              syncSessionGroupsFromUser(userData);
              setIsAuthenticated(true);
            } catch {
              setIsAuthenticated(false);
            }
            break;
          }
          case 'signOut':
            setIsAuthenticated(false);
            setUserAccess([]);
            setIsWebAcess(false);
            localStorage.removeItem('is-web-page');
            sessionStorage.removeItem('otp_validation_in_progress');
            break;
          case 'cognitoHostedUI_failure':
            break;
          default:
            break;
        }
      }
    );
    return () => {
      if (typeof unsubscribe === 'function') unsubscribe();
    };
  }, [syncSessionGroupsFromUser]);

  /** Handling Reloadin or Refreshing page (from browser) */
  // useEffect(() => {
  //   const pageAccessedByReload = (
  //     (window.performance.PerformanceNavigationTiming && window.performance.PerformanceNavigationTiming.type === 1) ||
  //     window.performance
  //       .getEntriesByType('navigation')
  //       .map((nav) => nav.type)
  //       .includes('reload')
  //   );

  //   console.log(pageAccessedByReload);
  //   if (pageAccessedByReload) {
  //       history.push('/');
  //   }
  // }, [])

  useEffect(() => {
    const element = document.getElementById('body-wrapper');
    const theme = sessionStorage.getItem('theme');
    if (theme === 'True') {
      element.classList.add('light-theme');
    } else {
      element.classList.remove('light-theme');
    }

    // Check if we're on a modern layout route before authenticating
    const currentPath = window.location.pathname;
    const isModernRoute = routes.some(
      (route) => route.layout === ModernLayout && 
      (route.exact ? currentPath === route.path : currentPath.startsWith(route.path))
    );

    authenticateCurrentUser()
      .then((data) => {
        syncSessionGroupsFromUser(data);
        setIsAuthenticated(true);
        
        // IMPORTANT: Don't redirect if we're on a modern layout route
        // The route will handle rendering, and we don't want to redirect away from it
        if (isModernRoute || shouldExcludeFromRedirect()) {
          console.log('[Routes] On modern/excluded route, skipping redirect:', currentPath);
          return;
        }
      })
      .catch(() => {
        setIsAuthenticated(false);
        localStorage.clear();
        sessionStorage.clear();
      });
  }, [syncSessionGroupsFromUser]);

  return (
    <Router history={history}>
      <Switch>
        <PublicRoute
          userAccess={userAccess}
          isWebAcess={isWebAcess}
          exact
          path="/login"
          isLogin={isAuthenticated}
          component={LoginPage}
        />
        <PublicRoute
          userAccess={userAccess}
          isWebAcess={isWebAcess}
          exact
          path="/signup"
          isLogin={isAuthenticated}
          component={SignUp}
        />
        <PublicRoute
          userAccess={userAccess}
          isWebAcess={isWebAcess}
          path="/forgot-password"
          isLogin={isAuthenticated}
          component={ForgotPassword}
        />
        <PublicRoute
          userAccess={userAccess}
          isWebAcess={isWebAcess}
          path="/reset-password"
          isLogin={isAuthenticated}
          component={ResetPassword}
        />
        <Route path="/notFound" component={NotFoundPage} />
        <Route
          path="/asset-management/maintenance-history"
          component={isAuthenticated ? EquipmentCheckComingsoon : LoginPage}
        />
        <Route path="/TechnicalPage/pdf/:id" component={TechnicalPDFViewer} />
        <Route path="/heat-profile/pdf/:id" component={HeatProfilePDFViewer} />
        <Route path="/heat-profile/image/:id" component={HeatProfileImageViewer} />

        {/* render={() => (isAuthenticated ? <NotFoundPage /> : <Redirect to="/login" />)}/> */}
        {/* ModernLayout routes render independently with their own sidebar - MUST be first */}
        {routes
          .filter((route) => {
            // Check if route uses ModernLayout by comparing function or checking name
            const isModern = route.layout === ModernLayout || 
                            (route.layout && (route.layout.name === 'ModernLayout' || route.layout.displayName === 'ModernLayout'));
            return isModern;
          })
          .map((route) => (
            <Route
              key={route.path}
              path={route.path}
              exact={route.exact}
              render={(props) => {
                // For modern routes, allow rendering even if auth is still checking
                // The component will handle auth state
                if (!isAuthenticated) {
                  // Check if user is actually logged in (for new tabs)
                  const token = localStorage.getItem('ap_idToken');
                  if (!token) {
                    return <Redirect to="/login" />;
                  }
                  // If token exists, allow rendering (auth check is in progress)
                }
                return (
                  <route.layout {...props}>
                    <route.component
                      {...props}
                      isAuthenticated={isAuthenticated}
                      isShowProjectData={isShowProjectData}
                      setIsShowProjectData={setIsShowProjectData}
                    />
                  </route.layout>
                );
              }}
            />
          ))}

        {/* Legacy routes use the existing Layout wrapper with legacy Sidebar */}
        {/* Render legacy routes - this Route only matches if no ModernLayout route matched above */}
        <Route
          render={({ location }) => {
            // CRITICAL: Check if current path is a ModernLayout route FIRST
            const isModernLayoutRoute = routes.some(
              (route) => {
                const layoutMatches = route.layout === ModernLayout;
                const pathMatches = route.exact 
                  ? location.pathname === route.path 
                  : location.pathname.startsWith(route.path);
                return layoutMatches && pathMatches;
              }
            );
            
            // If it's a modern layout route, don't render legacy wrapper at all
            if (isModernLayoutRoute) {
              console.log('[Routes] Blocking legacy wrapper - ModernLayout route detected:', location.pathname);
              return null;
            }
            
            // Check if it's a known legacy route
            const isLegacyRoute = routes.some(
              (route) => route.layout !== ModernLayout && 
              (route.exact ? location.pathname === route.path : location.pathname.startsWith(route.path))
            );
            
            // Only render legacy wrapper for legacy routes
            if (!isLegacyRoute && location.pathname !== '/notFound') {
              return null; // Let 404 or other handlers catch it
            }
            
            // Render legacy layout wrapper for legacy routes only
            return (
              <Layout className="h-100">
                <Sidebar setIsShowProjectData={setIsShowProjectData} />
                <Layout.Content className="h-100 pt-3 px-4">
                  <Switch location={location}>
                    {routes
                      .filter((route) => route.layout !== ModernLayout)
                      .map((route) => (
                        <PrivateRoute
                          key={route.path}
                          path={route.path}
                          exact={route.exact}
                          isLogin={isAuthenticated}
                          component={(props) => (
                            <route.layout {...props}>
                              <route.component
                                {...props}
                                isAuthenticated={isAuthenticated}
                                isShowProjectData={isShowProjectData}
                                setIsShowProjectData={setIsShowProjectData}
                              />
                            </route.layout>
                          )}
                        />
                      ))}
                    <PrivateRoute
                      path="*"
                      component={() => <Redirect to="/notFound" />}
                    />
                  </Switch>
                </Layout.Content>
              </Layout>
            );
          }}
        />
        {/* No-access users: only this page, no sidebar; redirect web-page/dashboard etc. here */}
        <Route
          exact
          path="/no-access"
          render={() =>
            isAuthenticated && isNoAccessUser ? (
              <NoAccessPage />
            ) : (
              <Redirect to={isAuthenticated ? '/dashboard' : '/login'} />
            )
          }
        />

        {isAuthenticated && isNoAccessUser ? (
          <Redirect to="/no-access" />
        ) : (
          <>
            <Layout className="h-100">
              <Sidebar setIsShowProjectData={setIsShowProjectData} />
              <Layout.Content className="h-100 pt-3 px-4">
                <Switch>
                  {routes.map((route) => (
                    <PrivateRoute
                      key={route.path}
                      path={route.path}
                      exact={route.exact}
                      isLogin={isAuthenticated}
                      component={(props) => (
                        <route.layout {...props}>
                          <route.component
                            {...props}
                            isAuthenticated={isAuthenticated}
                            isShowProjectData={isShowProjectData}
                            setIsShowProjectData={setIsShowProjectData}
                          />
                        </route.layout>
                      )}
                    />
                  ))}
                  <PrivateRoute path="*" component={() => <Redirect to="/notFound" />} />
                </Switch>
              </Layout.Content>
            </Layout>
          </>
        )}
      </Switch>
    </Router>
  );
};

const mapStateToProps = ({ auth }) => {
  const isLogin = get(auth, 'isLogin', false);
  return {
    isLogin,
  };
};

export default connect(mapStateToProps)(AppContainer);
// export default AppContainer;
